import React from "react"
import TextareaAutosize from "react-textarea-autosize"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { useActiveBlock } from "app/regions/hooks/use-active-block"
import { useEditing } from "app/regions/hooks/use-editing"
import { useDebounce } from "hooks/use-debounced-value"
import { assembleSrc } from "../icons/icon"

export function Link({ block_id, styles }) {
  const { update, properties } = useBlocks(block_id)
  const { setActiveBlockId } = useActiveBlock()
  const editing = useEditing()

  const iconSrc = assembleSrc(
    properties.icon,
    styles.iconColor,
    "#000000",
    "icon-only"
  )
  const debouncedIconSrc = useDebounce(iconSrc, 300)

  const linkStyles = {
    display: "flex",
    alignItems: "center",
    padding: "1em",
    margin: "1em 0",
    textDecoration: "none",
    backgroundColor: styles.backgroundColor,
    borderWidth: styles.linkBorderWidth,
    borderColor: styles.linkBorderColor,
    borderRadius: styles.borderRadius,
    color: styles.textColor
  }

  const iconStyles = {
    margin: "0 1em 0 0",
    borderStyle: "solid",
    borderWidth: styles.iconBorderWidth,
    borderColor: styles.iconBorderColor,
    borderRadius: styles.borderRadius
  }

  function handleClick(e) {
    e.preventDefault()
    setActiveBlockId(block_id)
  }

  return (
    <a
      style={linkStyles}
      onClick={handleClick}
      href={properties.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {styles.useIcons && (
        <img
          src={debouncedIconSrc}
          style={iconStyles}
          width="40"
          height="40"
          alt=""
        />
      )}
      {editing ? (
        <TextareaAutosize
          value={properties.text}
          onChange={e => update({ text: e.target.value })}
          className="bg-transparent resize-none border-0 flex-grow ck-paragraph-font"
          style={{ fontWeight: "inherit" }}
        />
      ) : (
        <p>{properties.text}</p>
      )}
    </a>
  )
}
